import React, { useState } from 'react'
import { config } from '../utils/Constants'
import axios from 'axios'

function authorizationMobileApi() {

    const URL = config.url;

    const generateAuthorizationCodeMobile = async () => {
        try {
            const res = await axios.post(`${URL}/v1/Authorization/GenerateAuthorizationQrCode`, 
            {
                SessionID: sessionStorage.getItem("SessionMobile"),
                TypeID: 0,
                AdditionalInfo: "",
            }, 
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("TokenMobile"),
                }
            }
        );
            return res.data
        } catch (error) {
            console.error(error);
        }
    }

    const MobileAuthorize = async (authorizationCode) => {
        try {
            const res = await axios.post(`${URL}/v1/AuthMobile/MobileAuthorize`, 
            {
                SessionID: sessionStorage.getItem("SessionMobile"),
                AuthorizationCode: authorizationCode
            }, 
            {
                headers: {
                    'Content-Type': "application/json",
                    Authorization: sessionStorage.getItem("TokenMobile")
                }
            })
            return true;
        } catch (error) {
            console.error(error);
        }
    }

  return {
    generateAuthorizationCodeMobile,
    MobileAuthorize
  }
}

export default authorizationMobileApi